import { useState } from "react";

const KitchenHeader = ({
  kitchens = [],
  selectedKitchen = null,
  onKitchenChange,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <div
      className="
        bg-white
        px-2
        py-1
        flex
        items-center
        gap-2
      "
    >
      <div className="flex items-center gap-2 w-full md:w-auto">
        <span className="text-xs font-semibold text-gray-600 whitespace-nowrap">
          Kitchen
        </span>

        <div className="relative flex-1 md:w-60">
          <button
            onClick={() => setOpen((v) => !v)}
            className="
              w-full
              flex items-center justify-between
              px-2 py-0.5
              border border-gray-300
              rounded
              bg-white
              font-medium
              text-xs
              text-gray-800
              hover:border-gray-400
            "
          >
            <span className="truncate">
              {selectedKitchen?.kitchenName || "Select kitchen"}
            </span>

            <svg
              className={`w-3 h-3 transition-transform ${
                open ? "rotate-180" : ""
              }`}
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path d="M19 9l-7 7-7-7" />
            </svg>
          </button>

          {open && (
            <div
              className="
                absolute z-50 mt-2 w-full
                bg-white border border-gray-200
                rounded-lg shadow-lg
                max-h-64 overflow-y-auto
              "
            >
              {kitchens.map((kitchen) => (
                <div
                  key={kitchen.kitchenID}
                  onClick={() => {
                    onKitchenChange(kitchen);
                    setOpen(false);
                  }}
                  className="px-3 py-2 text-sm cursor-pointer hover:bg-gray-100"
                >
                  {kitchen.kitchenName}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default KitchenHeader;
